import {AbstractControl, UntypedFormArray, ValidationErrors, ValidatorFn} from '@angular/forms';

export function minimumTemplateCountValidator(minimum: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof UntypedFormArray)) {
      return;
    }

    const formArray = control as UntypedFormArray;
    return formArray.length < minimum ? { minimumElementNeeded: `You must add at least ${minimum} item(s)`} : null;
  };
}
